import { create } from 'zustand';
import {
  createFilterStore,
  FilterStoreState,
  EntityFilter,
  JoinOperator,
  Filter,
} from './filterStore';

interface ReplacementsEntityFilter extends Omit<EntityFilter, 'getBuildDataFilterFunction'> {
  filter: {
    address: Filter[];
    contractName: Filter[];
    replacementScheduledDate: Filter[];
    replacementStatus: Filter[];
    roeStatus: Filter[];
    serviceLineSide: Filter[];
  };
  setAddressFilter: (address: Filter[]) => void;
  setContractNameFilter: (contractName: Filter[]) => void;
  setReplacementScheduledDateFilter: (replacementScheduledDate: Filter[]) => void;
  setReplacementStatusFilter: (replacementStatus: Filter[]) => void;
  setRoeStatusFilter: (roeStatus: Filter[]) => void;
  setServiceLineSideFilter: (serviceLineSide: Filter[]) => void;
  resetFilters: () => void;
}

export interface ReplacementsFilterSlice extends FilterStoreState {
  replacements: ReplacementsEntityFilter;
}

const filterDefault = {
  address: [] as Filter[],
  contractName: [] as Filter[],
  replacementScheduledDate: [] as Filter[],
  replacementStatus: [] as Filter[],
  roeStatus: [] as Filter[],
  serviceLineSide: [] as Filter[],
};

const initialState = (set, get) => ({
  replacements: {
    filter: filterDefault,
    setAddressFilter: (address: Filter[]) =>
      set((state) => ({
        replacements: {
          ...state.replacements,
          filter: {
            ...state.replacements.filter,
            address,
          },
        },
      })),
    setContractNameFilter: (contractName: Filter[]) =>
      set((state) => ({
        replacements: {
          ...state.replacements,
          filter: {
            ...state.replacements.filter,
            contractName,
          },
        },
      })),
    setReplacementScheduledDateFilter: (replacementScheduledDate: Filter[]) =>
      set((state) => ({
        replacements: {
          ...state.replacements,
          filter: {
            ...state.replacements.filter,
            replacementScheduledDate,
          },
        },
      })),
    setReplacementStatusFilter: (replacementStatus: Filter[]) =>
      set((state) => ({
        replacements: {
          ...state.replacements,
          filter: {
            ...state.replacements.filter,
            replacementStatus,
          },
        },
      })),
    setRoeStatusFilter: (roeStatus: Filter[]) =>
      set((state) => ({
        replacements: {
          ...state.replacements,
          filter: {
            ...state.replacements.filter,
            roeStatus,
          },
        },
      })),
    setServiceLineSideFilter: (serviceLineSide: Filter[]) =>
      set((state) => ({
        replacements: {
          ...state.replacements,
          filter: {
            ...state.replacements.filter,
            serviceLineSide,
          },
        },
      })),
    resetFilters: () =>
      set((state) => ({
        replacements: {
          ...state.replacements,
          filter: filterDefault,
        },
      })),
    // from FilterStoreState
    joinOperator: 'and' as JoinOperator, // Defaults to and
    setJoinOperator: (joinOperator: JoinOperator) =>
      set((state) => {
        return {
          ...state,
          replacements: { ...state.replacements, joinOperator },
        };
      }),
    getQueryParamRepresentation: (respectGlobalFilters = true) =>
      get().getQueryParamRepresentationByEntity('replacements', ['properties'])(
        respectGlobalFilters
      ),
  },
});

const useReplacementsFilterStore = create<ReplacementsFilterSlice>((set, get) =>
  createFilterStore<ReplacementsFilterSlice>(set, get, initialState(set, get))
);

export default useReplacementsFilterStore;
